import { CascadiaMiniIcon } from "@certn/cascadia-tokens";
import { InputProps, Input as AriaInput } from "react-aria-components";

import { InputContainer } from "./InputContainer";

interface Props extends InputProps {
  leftIcon?: CascadiaMiniIcon;
  rightIcon?: CascadiaMiniIcon;
  clearable?: boolean;
  compact?: boolean;
  onClear?: () => void;
}

export function Input(props: Props) {
  const { leftIcon, rightIcon, clearable, compact, onClear, ...inputProps } =
    props;

  return (
    <InputContainer
      leftIcon={leftIcon}
      rightIcon={rightIcon}
      clearable={clearable}
      compact={compact}
      onClear={onClear}
    >
      <AriaInput {...inputProps} />
    </InputContainer>
  );
}
